module.exports = __webpack_public_path__ + "img/BDDI-logo.ce26981c.png";